import { Box, Flex } from '@chakra-ui/react';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { TextRegular, TextSemiBold } from 'UiKit/typography';

import { ArrowLeftIcon } from 'Asset/icon';
import { Condition } from 'Component/others';
import { useForgotPasswordState } from 'View/forgot-password/state';

import styles from './styles.module.css';
import { useTranslation } from 'react-i18next';

const Head = ({ isSent }) => {
  const navigate = useNavigate();
  const { resetState } = useForgotPasswordState();
  const [isNavigating, setIsNavigating] = useState(false);
  const { t } = useTranslation('login');

  const handleBackButton = () => {
    if (isNavigating) return;
    setIsNavigating(true);
    resetState();
    navigate('/login');
  };

  return (
    <Box className={styles['section-head__container']} data-testid="forgot-password-head">
      <Flex className={styles['section-head__container--top']}>
        <ArrowLeftIcon width="26px" height="26px" onClick={handleBackButton} />
        <TextSemiBold className={styles['page__title']}>{t('forgotPasswordPage.title')}</TextSemiBold>
      </Flex>

      <Condition statement={!isSent}>
        <TextRegular className={styles['description__text']}>{t('forgotPasswordPage.description')}</TextRegular>
      </Condition>
    </Box>
  );
};

export default Head;
